import type { Modifier } from '@dnd-kit/core'

/** Sürüklenen satır yalnız yukarı aşağı gidiyor, yana kaymıyor. */
export const restrictToVerticalAxis: Modifier = ({ transform }) => ({ ...transform, x: 0 })
